import { CheckboxInput } from '@framework/form';
import React from 'react';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText';
import { getWidgetProps } from '../common/util/getWidgetProps';
import type { IBooleanWidget } from './IBooleanWidget';

export interface IBooleanWidgetComponentProps
  extends IWidgetComponentProps<IBooleanWidget> {}

export function BooleanWidgetComponent(props: IBooleanWidgetComponentProps) {
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options?.helpText} />}
      layout={{
        hideVisualLabel: options?.hideLabel,
        removeLabelSpace: props.widget.layout?.isTableColumn,
      }}
      className="remove-requires-asterisk"
      readonly={options.readonly}
    >
      <CheckboxInput
        readOnly={props.readonly}
        name={options.name}
        tabIndex={options.preview ? -1 : undefined}
      >
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </CheckboxInput>
    </ConfigFormItem>
  );
}
